import { IApiGetLpAdapterSchemaRes } from '@cbridge-packages/api-admin';
import { ILpAdapterSchemas } from './lpAdapters.interface';

export namespace LpAdaptersTranslator {
  // Split shape is valid only with both schemas present; a partial response
  // is treated as no schema at all (the form falls back to the plain grid).
  export function fromApiSchemas(res: IApiGetLpAdapterSchemaRes): ILpAdapterSchemas | undefined {
    if (res.pricing && res.trading) {
      return { pricing: res.pricing, trading: res.trading };
    }

    return res.schema
      ? { pricing: res.schema, trading: res.schema }
      : undefined;
  }
}
